import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { confirmRemovalAsGuardian } from '../animal-status-update'

Vue.use(VueAxios, axios)

export default Vue.component(
  'mark-as-deceased',
  {
    data () {
      return {
        showModal: false,
        showFailureMessage: false
      }
    },
    computed: {
      formChangesPresent () {
        return this.$parent.anyChanges
      },
      transferPending () {
        return this.$root.transferPending
      }
    },
    methods: {
      confirmRemovalAsGuardian,
      clearModal () {
        this.showModal = false
        this.showFailureMessage = false
      }
    }
  }
)
